module.exports = __webpack_public_path__ + "img/cable-car.d38dc012.svg";